export default __webpack_public_path__ + "static/media/shield-front.160b7bf0.svg";